import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:17001";

export const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor for logging
api.interceptors.request.use(
  (config) => {
    console.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`);
    return config;
  },
  (error) => {
    console.error("API Request Error:", error);
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error("API Response Error:", error);
    return Promise.reject(error);
  }
);

// Health check
export const healthCheck = () => api.get("/");

// Configuration APIs
export const getLocations = () => api.get("/api/locations");
export const getToolTypes = () => api.get("/api/tool-types");
export const getToolsByType = (toolType: string) =>
  api.get(`/api/tools/${toolType}`);

//area apis
export const getTagsByMeasurement = () => api.get("/api/tags");

export const getFieldsByTags = (areaTag: string) =>
  api.get(`/api/tags/fields/${areaTag}`);

export const getValueByAreaFields = (
  areaTag: string,
  fields: string,
  start: string,
  stop: string
) =>
  api.get(
    `/api/area/fields?areaTag=${areaTag}&fields=${fields}&start=${start}&stop=${stop}`
  );

//inspection log api

export const getInspectionLogs = (startDate: string, stopDate: string) =>
  api.get(`/api/inspection?&start=${startDate}&stop=${stopDate}`);

//defect api

export const getDefectLogs = (startDate: string, stopDate: string) =>
  api.get(`/api/defect?&start=${startDate}&stop=${stopDate}`);

// Metrics APIs
export const getToolMetrics = (toolName: string, location: string) =>
  api.get(`/api/metrics/${toolName}`, { params: { location } });

export const getToolHistory = (
  toolName: string,
  location: string,
  hours: number = 24
) => api.get(`/api/history/${toolName}`, { params: { location, hours } });

export const writeMetrics = (data: {
  toolName: string;
  location: string;
  temperature: number;
  pressure: number;
  flowRate: number;
  power: number;
}) => api.post("/api/metrics", data);

// Analytics APIs
export const getToolAlarms = (toolName: string, location: string) =>
  api.get(`/api/alarms/${toolName}`, { params: { location } });

export const getToolOEE = (toolName: string, location: string) =>
  api.get(`/api/oee/${toolName}`, { params: { location } });

// InfluxDB APIs
export const testInfluxConnection = () => api.get("/api/test-influx");

// Types for API responses
export interface ToolMetrics {
  tool_name: string;
  location: string;
  temperature: number;
  pressure: number;
  flow_rate: number;
  power: number;
  timestamp: string;
}

export interface HistoricalData {
  time: string;
  temperature: number;
  pressure: number;
  flow_rate: number;
  power: number;
}

export interface Alarm {
  name: string;
  value: number;
  color: string;
}

export interface OEEData {
  name: string;
  value: number;
  color: string;
}

export default api;
